import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "AddDeviceLink" })
export default class AddDeviceLink extends Vue {
    public localizer: any = Localizer;
    public showForm: boolean = false;

    public setShowForm() {
        this.showForm = !this.showForm;
    }

    public setAnalytics() {
        GTagHelper.sendEvent("click", "device_add");
    }
};